export default "__VITE_ASSET__ac64b3f4__"